<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div id="dados-formulario" class="card">
        <div class="card-body">
          <div id="titulo">
					  <div class="row">
						  <div class="col-sm-12 col-md-12">
								<h4>Editar Conceito</h4>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-12 col-md-12 pull-right">
								<input class="btn btn-success" type="submit" value="Salvar" v-on:click="salvar">
                <router-link id="btnNovoCliente" class="btn btn-warning" to="/convencoes">
									<span class="glyphicon glyphicon-back"></span> Fechar
								</router-link>
							</div>
						</div>
					</div>

	//
	@Column(name = "inicio_fim_jornada_tolerancia")
	private String inicioFimJornadaTolerancia;
	@Column(name = "macro_fora_margem_horario_almoco")
	private String macroForaMargemHorarioAlmoco;

					<div class="row">
            <div class="col-sm-12 col-md-12">
							<input type="hidden" v-model="model.id" />
							<div class="row">
								<div class="form-group col-sm-10 col-md-10">
									<label>Nome:</label><br>
									<input class="form-control" v-model="model.nome" required="required"
										autofocus="autofocus" />
								</div>
							</div>
              <div class="row">
								<div class="form-group col-sm-10 col-md-10">
									<label>Descrição:</label><br>
									<input class="form-control" v-model="model.descricao" required="required"
										autofocus="autofocus" />
								</div>
							</div>


							<div class="row">
								<div class="form-group col-sm-6 col-md-6">
									<label>Data Inicio:</label><br>
                  <input-data-picker class="pula data form-control" v-model="model.dataInicio" />
								</div>

								<div class="form-group col-sm-6 col-md-6">
									<label>Data Final:</label><br>
									<input-data-picker class="pula data form-control" v-model="model.dataFinal" />
								</div>
							</div>
              <template v-if="$auth.check('P110')">
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Cliente:</label><br>
                    <input type="hidden" id="clienteId" v-model="model.clienteId" />
                    <buscar-cliente  v-validate="'required'" id="clienteNome" name="clienteNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :required="true" :errors="errors.has('clienteNome')" v-model="model.clienteNomeFantasia" :on-select="setarCliente" :on-blur="verificarCliente"/>
                  </div>
                </div>
              
              </template>


              <div class="row">
                <div class="form-group col-sm-3 col-md-3">
                  <label>Início Jornada Segunda a Quinta:</label><br>
                  <input-hora-picker-ss v-model="model.inicioJornadaSegundaQuinta" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-3 col-md-3">
                  <label>Fim Jornada Segunda a Quinta:</label><br>
                  <input-hora-picker-ss v-model="model.fimJornadaSegundaQuinta" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-2 col-md-2">
                  <label>Margem Almoço Inicio:</label><br>
                  <input-hora-picker-ss v-model="model.margemInicioAlmocoSegundaQuinta" class="form-control pula hora" />
                </div>
                <div class="form-group col-sm-2 col-md-2">
                  <label>Margem Almoço Final:</label><br>
                  <input-hora-picker-ss v-model="model.margemFinalAlmocoSegundaQuinta" class="form-control pula hora" />
                </div>

                <div class="form-group col-sm-2 col-md-2">
                  <label>Duração Jornada:</label><br>
                  <input-hora-picker-ss v-model="model.jornadaDuracaoSegundaQuinta" class="form-control pula hora" />
                </div>

              </div>

              <div class="row">
                <div class="form-group col-sm-3 col-md-3">
                  <label>Início Jornada Sexta:</label><br>
                  <input-hora-picker-ss v-model="model.inicioJornadaSexta" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-3 col-md-3">
                  <label>Fim Jornada Sexta:</label><br>
                  <input-hora-picker-ss v-model="model.fimJornadaSexta" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-2 col-md-2">
                  <label>Margem Almoço Inicio:</label><br>
                  <input-hora-picker-ss v-model="model.margemInicioAlmocoSexta" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-2 col-md-2">
                  <label>Margem Almoço Final:</label><br>
                  <input-hora-picker-ss v-model="model.margemFinalAlmocoSexta" class="form-control pula hora" />    
                </div>

                <div class="form-group col-sm-2 col-md-2">
                  <label>Duração Jornada:</label><br>
                  <input-hora-picker-ss v-model="model.jornadaDuracaoSexta" class="form-control pula hora" />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm-3 col-md-3">
                  <label>Início Jornada Sábado:</label><br>
                  <input-hora-picker-ss v-model="model.inicioJornadaSabado" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-3 col-md-3">
                  <label>Final Jornada Sábado:</label><br>
                  <input-hora-picker-ss v-model="model.fimJornadaSabado" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-2 col-md-2">
                  <label>Margem Almoço Inicio:</label><br>
                  <input-hora-picker-ss v-model="model.margemInicioAlmocoSabado" class="form-control pula hora" />
                </div>
                <div class="form-group col-sm-2 col-md-2">
                  <label>Margem Almoço Final:</label><br>
                  <input-hora-picker-ss v-model="model.margemFinalAlmocoSabado" class="form-control pula hora" />
                </div>

                <div class="form-group col-sm-2 col-md-2">
                  <label>Duração Jornada:</label><br>
                  <input-hora-picker-ss v-model="model.jornadaDuracaoSabado" class="form-control pula hora" />
                </div>
                
              </div>

              <div class="row">
                <div class="form-group col-sm-3 col-md-3">
                  <label>Início Jornada Domingo:</label><br>
                  <input-hora-picker v-model="model.inicioJornadaDomingo" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-3 col-md-3">
                  <label>Final Jornada Domingo:</label><br>
                  <input-hora-picker-ss v-model="model.fimJornadaDomingo" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-2 col-md-2">
                  <label>Margem Almoço Inicio:</label><br>
                  <input-hora-picker-ss v-model="model.margemInicioAlmocoDomingo" class="form-control pula hora" />    
                </div>
                <div class="form-group col-sm-2 col-md-2">
                  <label>Margem Almoço Final:</label><br>
                  <input-hora-picker-ss v-model="model.margemFinalAlmocoDomingo" class="form-control pula hora" />    
                </div>

                <div class="form-group col-sm-2 col-md-2">
                  <label>Duração Jornada:</label><br>
                  <input-hora-picker-ss v-model="model.jornadaDuracaoDomingo" class="form-control pula hora" />
                </div>
              </div>
            </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      model: {
        id: '0',
        ativo: true,
        nome: '',
        avisoVenda: false,
        bloqueadoVenda: false
      }
    }
  },
  created: function () {
    this.buscar()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/jornadasConvencoes/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        var dados = response.data
        self.model.id = dados.id
        self.model.ativo = dados.ativo
        self.model.nome = dados.nome
        self.model.avisoVenda = dados.avisoVenda
        self.model.bloqueadoVenda = dados.bloqueadoVenda
      })
    },
    salvar: function () {
      var self = this
      console.log(JSON.stringify(self.model))
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      var url = '/api/jornadasConvencoes/salvar'
      axios.post(url, JSON.stringify(self.model), config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.$router.replace('/conceitos')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/convencoes/ConvencoesEditar.vue